<template>
  <div
    id="profile"
    role="tabpanel"
    data-mh="log-tab"
    class="tab-pane active"
  >
    <div class="title h6">
      Login to your Account
    </div>
    <form
      class="content"
      @submit.prevent="loginUser"
    >
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div
            class="form-group label-floating is-empty"
            :class="{'is-focused' : inputIsFocused1 || user.username.length >0 }"
          >
            <label class="control-label">Your Username</label>
            <input
              v-model="user.username"
              placeholder=""
              type="text"
              class="form-control"
              @focus="setFocused('inputIsFocused1')"
            >
          </div>
          <div
            class="form-group label-floating is-empty"
            :class="{'is-focused' : inputIsFocused2 || user.password.length >0 }"
          >
            <label class="control-label">Your Password</label>
            <input
              v-model="user.password"
              placeholder=""
              type="password"
              class="form-control"
              @focus="setFocused('inputIsFocused2')"
            >
          </div>
          <button
            class="btn btn-lg btn-primary full-width"
            type="submit"
            name="submit"
          >
            <span>Login</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// import { getMonth, getYear } from 'date-fns'

export default {
  name: 'LoginForm',
  data () {
    return {
      user: {
        username: '',
        password: '',
      },
      inputIsFocused1: false,
      inputIsFocused2: false,
    }
  },
  computed: {},
  mounted() {
    // let app = this.$route.query.app;
    // if (['personal', 'familial', 'financial', 'mental', 'physical', 'social', 'spiritual', 'vocational'].includes(app)) {
    //     this.user.username = app;
    //     this.user.password = '';
    //     this.user.db = app;
    // }
  },
  methods: {
    setFocused(param) {
      this.inputIsFocused1 = false
      this.inputIsFocused2 = false
      this[param] = true
    },
    // eslint-disable-next-line
      loginUser: function() { // !!!! this messes up if I use arrow function
      const credentials = {
        username: this.user.username,
        password: this.user.password
      }
      let path = window.location.pathname;
      let db = ''
      if (path.includes('per')) {
        db = 'per';
      }
      if (path.includes('men')) {
        db = 'men';
      }
      if (path.includes('spi')) {
        db = 'spi';
      }
      if (path.includes('voc')) {
        db = 'voc';
      }
      if (path.includes('soc')) {
        db = 'soc';
      }
      if (path.includes('phy')) {
        db = 'phy';
      }
      if (path.includes('fam')) {
        db = 'fam';
      }
      if (path.includes('fin')) {
        db = 'fin';
      }
      credentials.db = db;

      this.$store.dispatch('account/login', { credentials })
        .then(() => {
          let path = window.location.pathname;
          let route = ''
          if (path.includes('per')) {
            route = `/areas`;
          }
          if (path.includes('men')) {
            route = '/articles';
          }
          if (path.includes('spi')) {
            route = '/courses'
          }
          if (path.includes('voc')) {
            route = '/list';
          }
          if (path.includes('soc')) {
            route = '/list';
          }
          if (path.includes('phy')) {
            route = '/list';
          }
          if (path.includes('fam')) {
            route = '/list';
          }
          if (path.includes('fin')) {
            route = '/list';
          }
          this.$router.push(route)
        })
        .catch(err => console.log(err))
    }
  }
}
</script>
